




















import 'reflect-metadata'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { ChainMap } from '@/known_blockchains'

@Component({})
export default class TxFilter extends Vue {
    @Prop() chains!: ChainMap[]
    items: any[] = []
    selection: any[] = []

    created() {
        this.items = this.chains.map((chain: ChainMap) => ({
            id: chain.id,
            name: `${chain.name} (${chain.fullname})`,
            children: chain.txTypes.map((type) => ({
                id: type[0],
                name: type[1].long,
            })),
        }))

        this.selection = this.items.flatMap((item) => item.children)

        this.$emit(
            'change',
            this.selection.map((val) => val.id)
        )
    }

    @Watch('selection')
    onSelectionChanged() {
        this.$emit(
            'change',
            this.selection.map((val) => val.id)
        )
    }
}
